import qs from 'qs';
import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';
import http from 'utils/http';
import { createSnack } from 'snackbar/snackbarSlice';

const initialState = {
  error: '',
  productBalance: null,
};

const reducers = {
  fetchProductBalanceSuccess(state, { payload }) {
    return R.assoc('productBalance', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'productBalance',
  reducers,
});

const { fetchProductBalanceSuccess } = actions;

let fetchController;
export const fetchProductBalance =
  (queryParams = {}) =>
  dispatch => {
    const paramString = qs.stringify(queryParams, {
      allowDots: true,
      encode: false,
    });
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    return http
      .get(`/product-transfer-orders/get-originator-location-product-balance?${paramString}`, {
        signal,
      })
      .then(res => {
        dispatch(fetchProductBalanceSuccess(res.data));
      })
      .catch(error => {
        dispatch(
          createSnack({
            message: error.response.data.title,
            options: { variant: 'error' },
          })
        );
      });
  };

export default reducer;
